import EIPCard from "@/components/card/list";
import { useAccount, useNetwork } from "wagmi";
import { useRouter } from "next/router";
import { defaultChain, UpbondConnector } from "src/config";
import Connect from "@/components/button/connect";
import { useConnect } from "wagmi";
import { useEffect, useState } from "react";
import { publicProvider } from "wagmi/providers/public";
import { configureChains } from "wagmi";

import { polygon, polygonMumbai } from "@wagmi/core/chains";
export default function Index() {
  const router = useRouter();
  const { connect } = useConnect();
  const { chains } = configureChains([polygon, polygonMumbai], [publicProvider()]);
  const { selectedAddress, verifier, loggedIn, rehydrate, state } = router.query;
  const { isConnected } = useAccount();
  const [connected, setConnected] = useState(false);
  const [loginData, setLoginData] = useState({});
  useEffect(() => {
    const selectedAddressLocal = localStorage.getItem("autoLogin");
    if (selectedAddress) {
      const autoLoginData = JSON.stringify({ selectedAddress, verifier, loggedIn, rehydrate, state });
      localStorage.setItem("autoLogin", autoLoginData);
      const upbondLogin = new UpbondConnector({
        chains,
        options: {
          buildEnv: "development",
          enableLogging: true,
          buttonPosition: "bottom-left",
          showTorusButton: true,
        },
      });
      connect({ connector: upbondLogin });
    }
    if (!selectedAddress && selectedAddressLocal) {
      const autoLoginData = JSON.parse(selectedAddressLocal);
      if (!selectedAddress && autoLoginData) {
        if (autoLoginData.selectedAddress && autoLoginData.selectedAddress != "undefined") {
          router.push({
            pathname: "/",
            query: {
              selectedAddress: autoLoginData.selectedAddress,
              verifier: autoLoginData.verifier,
              loggedIn: autoLoginData.loggedIn,
              rehydrate: autoLoginData.rehydrate,
              state: autoLoginData.state,
            },
          });

          console.log("@kog bisa kesini", selectedAddress);
          // window.location.href = `?selectedAddress=${autoLoginData.selectedAddress}&verifier=${autoLoginData.verifier}&loggedIn=${autoLoginData.loggedIn}&rehydrate=${autoLoginData.rehydrate}&state=${autoLoginData.state}`;
        }
      }
    }
  }, [selectedAddress]);

  useEffect(() => {
    isConnected && setConnected(true);
  }, [isConnected]);
  return connected ? (
    <EIPCard />
  ) : (
    <div className="bg-white">
      <div className="relative bg-white">
        <div aria-hidden="true" className="absolute" />

        <div className="mx-auto flex max-w-3xl flex-col items-center py-32 px-6 text-center sm:py-64 lg:px-0">
          <h1 className="text-4xl font-bold tracking-tight text-black lg:text-6xl">Wallet Connect Tester (Deprecated)</h1>
          <div className="mt-4 text-xl text-black">Please connect wallet first to use overpower tester</div>
        </div>
      </div>
    </div>
  );
}
